const ON_CHANGE_DEBOUNCE_TIMER = 300;
const RESIZE_DEBOUNCE_TIMER = 250;
const SLIDE_CHANGE_DEBOUNCE_TIMER = 300;

const VALUE_PATTERNS = {
  boolean: /^(true|false)$/,
  number: /^\d+(\.\d+)?$/,
  array: /^\[(.*)\]$/,
};

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

const EXCLUDED_ANCHOR_LINKS = [
  '#MainContent',
  '#swym-wishlist',
  '#recover',
  '#login',
];
